import React, { useEffect, useRef, useState } from "react";
import TablePaymentPage from "./TableCouponPage";
import { Spin } from "antd";
import MessageConfirmModal from "../../components/messageModal/MessageConfirmModal";
import TableCouponPage from "./TableCouponPage";

const CouponPage = () => {
  const messageModalRef = useRef("");
  const [loading, setLoading] = useState(false);

  return (
    <div className="box-shadow h-100 w-100">
      <div className="w-100 h-100 overflow-auto">
        <Spin spinning={loading}>
          <div className="w-100">
            <TableCouponPage messageModalRef={messageModalRef} loading={loading} setLoading={setLoading} />
          </div>
        </Spin>
        <MessageConfirmModal textCentered ref={messageModalRef} />
      </div>
    </div>
  )
}

export default CouponPage